import React from 'react'
import ContainerLayout from '../../../../components/container-layout/ContainerLayout';
import { ContainerBox } from './style'
import { IconComponents, icons } from '../../../../assets/icons/icons';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import StateComponents from '../../../../components/state-component/StateComponents';
import { TransitionGroup } from "react-transition-group";
import { Collapse, IconButton, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import clsx from 'clsx'
import { MENU_RENDER_VIEW_ENUM, website_menu_data } from './enum.menu'
import ContainerButton from '../../../../components/button/ContainerButton';
import { ManageState } from './manageStete';
import ModalCustom from '../../../../components/modal/modalCustomCms';
import { debouncedApiCall } from '../../../../utils/app.utils';


type Props = {}


const MenuStructure: React.FC<Props> = ({ }: Props) => {
    const {
        selected_id_menu,
        handleChangeMenuDetail,
        handleGetDetailMenu,
        // handleOpenMenu,
        menu_data,
        menu_detail,
        id_menu,
        handleCloseModal,
        showModal,
        setShowModal,
        handleUpdateMenu,
        menu_all_data,
        handleDeleteMenu,
        set_menu_detail,
        handleCreateMenu,
        setSearchMenu,
        checkPermit
        // set_selected_id_menu
    } = ManageState();

    const renderSubMenu = (subMenu: any[], pl: number): React.ReactNode => {
        return (
            <List component="div" disablePadding>
                {subMenu.map((menu: any, index: number) => {
                    return (
                        <>
                            <ListItemButton key={menu?.id_menu + index} sx={{ ml: pl }} onClick={() => handleGetDetailMenu(menu?.id_menu)}>
                                <ListItemIcon>
                                    <ArrowForwardIosIcon sx={{
                                        transform: (id_menu.includes(menu?.id_menu) && menu?.children?.length) > 0 ? "rotate(90deg)" : "",
                                        transition: "all .5s ease"
                                    }} className={clsx('', {
                                        'text-active_color': selected_id_menu === menu?.id_menu
                                    })} />
                                    {selected_id_menu === menu?.id_menu ? (
                                        <IconComponents.MenuIconActive />
                                    ) : (
                                        <IconComponents.MenuIcon />
                                    )}
                                </ListItemIcon>
                                <ListItemText className={clsx('', {
                                    'text-active_color': selected_id_menu === menu?.id_menu
                                })} primary={menu?.menu_name} />
                            </ListItemButton>
                            {menu?.children?.length > 0 && (
                                <div className='w-full'>
                                    <TransitionGroup >
                                        {id_menu.includes(menu?.id_menu) && (
                                            <Collapse timeout="auto" unmountOnExit>
                                                {renderSubMenu(menu?.children, pl + 2)}
                                            </Collapse>
                                        )}
                                    </TransitionGroup>
                                </div>
                            )}
                        </>
                    )
                })}
            </List>
        )
    }


    // console.log(menu_data,'menu_data')

    return (
        <ContainerLayout
            title=''
            titleName='Menu Header'
            content={
                <div className='w-full flex flex-col lg:flex-row gap-5'>
                    <ContainerBox
                        title_name='เมนู Header เว็บไซต์'
                        content={
                            <div className='w-full flex flex-col mt-6 gap-4'>
                                {menu_data?.map((list) => {
                                    return (
                                        <div key={list.id_menu}>
                                            <span onClick={() => handleGetDetailMenu(list?.id_menu)} className='flex gap-1 cursor-pointer hover:opacity-50' key={list?.id_menu}>
                                                <div style={{
                                                    transform: (id_menu.includes(list?.id_menu) && list?.children?.length > 0) ? "rotate(90deg)" : "",
                                                    transition: "all .5s ease"
                                                }}>
                                                    <ArrowForwardIosIcon className={clsx('', {
                                                        'text-active_color': selected_id_menu === list?.id_menu
                                                    })} />
                                                </div>
                                                <div>
                                                    {selected_id_menu === list?.id_menu ? (
                                                        <IconComponents.MenuIconActive />
                                                    ) : (
                                                        <IconComponents.MenuIcon />
                                                    )}
                                                </div>
                                                <div className={clsx('', {
                                                    'text-active_color': selected_id_menu === list?.id_menu
                                                })}>
                                                    {list.menu_name || "-"}
                                                </div>
                                            </span>
                                            {list?.children?.length > 0 && (
                                                <div className='w-full'>
                                                    <TransitionGroup >
                                                        {id_menu.includes(list?.id_menu) && (
                                                            <Collapse timeout="auto" unmountOnExit>
                                                                {renderSubMenu(list?.children, 2)}
                                                            </Collapse>
                                                        )}
                                                    </TransitionGroup>
                                                </div>
                                            )}
                                        </div>
                                    )
                                })}
                                {menu_data?.length === 0 && (
                                    <div className='w-full'>
                                        ไม่มีข้อมูลเมนู
                                    </div>
                                )}
                            </div>
                        }
                        footer={
                            <div className='flex flex-col lg:flex-row w-full justify-center items-center gap-4'>
                                <StateComponents
                                    typeProps={[
                                        {
                                            seq: 1,
                                            type: "TEXT_FIELD",
                                            gridProps: {
                                                xs: 12
                                            },
                                            fieldProps: {
                                                startAdornment: <span className='mr-4'><icons.SearchNormal /></span>,
                                                onChange: (e) => debouncedApiCall({ searchItem: e.target.value, setItem: setSearchMenu }),
                                                placeholder: 'ค้นหา'
                                            }
                                        }
                                    ]}
                                />
                                <ContainerButton
                                    sxContainer={{ width: 300 }}
                                    buttonData={[
                                        {
                                            seq: 2,
                                            key: "ADD",
                                            hidden: !checkPermit.isCreated,
                                            buttonProps: {
                                                onClick: () => {
                                                    setShowModal("ADD");
                                                    set_menu_detail({
                                                        id_menu_ref: selected_id_menu,
                                                        menu_link: "",
                                                        menu_name: "",
                                                        menu_status_open: MENU_RENDER_VIEW_ENUM.CURRENT_TAB,
                                                        parent_menu_name: "",
                                                        group_menu: "",
                                                        is_not_show: false
                                                    })
                                                }
                                            },
                                            label: "เพิ่ม",
                                            type: "ADD"
                                        },
                                        {
                                            seq: 3,
                                            key: "EDIT",
                                            hidden: !checkPermit.isUpdate,
                                            buttonProps: {
                                                disabled: !selected_id_menu || !menu_detail.is_edit,
                                                onClick: () => setShowModal("EDIT")
                                            },
                                            label: "แก้ไข",
                                            type: "EDIT"
                                        },
                                        {
                                            seq: 4,
                                            key: "DELETE_BIN",
                                            hidden: !checkPermit.isDelete,
                                            buttonProps: {
                                                disabled: !selected_id_menu || !menu_detail.is_edit,
                                                onClick: () => selected_id_menu && handleDeleteMenu(selected_id_menu)
                                            },
                                            label: "ลบ",
                                            type: "DELETE_BIN"
                                        },
                                    ]}
                                />
                            </div>
                        }
                    />
                    <ContainerBox
                        title_name='รายละเอียดเมนู : หน้าหลัก'
                        content={
                            <>
                                {selected_id_menu && (
                                    <div className='w-full'>
                                        <StateComponents
                                            sxContainer={{ mt: 2 }}
                                            otherProps={{ spacing: 2 }}
                                            typeProps={[
                                                {
                                                    seq: 1,
                                                    type: "TEXT_FIELD",
                                                    gridProps: {
                                                        xs: 12
                                                    },
                                                    fieldProps: {
                                                        required: true,
                                                        heading: "ชื่อเมนู",
                                                        onChange: () => { },
                                                        disabled: true,
                                                        value: menu_detail.menu_name
                                                    }
                                                },
                                                {
                                                    seq: 2,
                                                    type: "TEXT_FIELD",
                                                    gridProps: {
                                                        xs: 12
                                                    },
                                                    fieldProps: {
                                                        required: true,
                                                        heading: "เชื่อมโยงลิงก์",
                                                        endAdornment: <IconButton disabled={!menu_detail.menu_status_open} onClick={() => {
                                                            if (menu_detail.menu_status_open === MENU_RENDER_VIEW_ENUM.CURRENT_TAB) {
                                                                window.location.href = menu_detail.menu_link
                                                            } else if (menu_detail.menu_status_open === MENU_RENDER_VIEW_ENUM.NEW_TAB) {
                                                                window.open(menu_detail.menu_link, '_blank')
                                                            }
                                                        }}>
                                                            <IconComponents.LinkIcon />
                                                        </IconButton>,
                                                        onChange: () => { },
                                                        disabled: true,
                                                        value: menu_detail.menu_link
                                                    }
                                                },
                                                {
                                                    seq: 3,
                                                    type: "RADIO",
                                                    gridProps: {
                                                        xs: 12
                                                    },
                                                    fieldProps: {
                                                        disabled: true,
                                                        row: true,
                                                        value: menu_detail.menu_status_open,
                                                        dataList: [
                                                            {
                                                                label: "อยู่ในหน้าเดิม",
                                                                value: MENU_RENDER_VIEW_ENUM.CURRENT_TAB
                                                            },
                                                            {
                                                                label: "เปิดหน้าใหม่",
                                                                value: MENU_RENDER_VIEW_ENUM.NEW_TAB
                                                            },
                                                        ],
                                                        heading: "การแสดงผล",
                                                        required: true
                                                    }
                                                },
                                                {
                                                    seq: 4,
                                                    type: "TEXT_FIELD",
                                                    gridProps: {
                                                        xs: 12,
                                                    },
                                                    fieldProps: {
                                                        disabled: true,
                                                        onChange: () => { },
                                                        value: menu_detail?.parent_menu_name,
                                                        heading: "อยู่ภายใต้เมนู"
                                                    }
                                                },
                                                // {
                                                //     seq: 5,
                                                //     type: "SELECT",
                                                //     gridProps: {
                                                //         xs: 12,
                                                //     },
                                                //     fieldProps: {
                                                //         labelId: "website_menu_data_id",
                                                //         options: website_menu_data,
                                                //         selectId: "website_menu_data",
                                                //         disabled: true,
                                                //         onChange: () => { },
                                                //         value: menu_detail?.group_menu,
                                                //         heading: "หมวดหมู่การแสดงผลที่แผนผังเว็บไซต์"
                                                //     }
                                                // },
                                                {
                                                    seq: 6,
                                                    type: "SWITCH",
                                                    gridProps: {
                                                        xs: 12
                                                    },
                                                    fieldProps: {
                                                        disabled: true,
                                                        label: "ไม่แสดงบน Header",
                                                        checked: menu_detail?.is_not_show,
                                                        onChange: () => { },
                                                    }
                                                }
                                            ]}
                                        />
                                    </div>
                                )}
                            </>
                        }
                        footer={
                            <div className='w-full'>
                                <ContainerButton
                                    buttonData={[
                                        {
                                            seq: 1,
                                            key: "EDIT",
                                            hidden: !checkPermit.isUpdate,
                                            buttonProps: {
                                                disabled: !selected_id_menu || !menu_detail.is_edit,
                                                onClick: () => setShowModal("EDIT")
                                            },
                                            label: "แก้ไข",
                                            type: "EDIT"
                                        },
                                        {
                                            seq: 2,
                                            key: "DELETE_BIN",
                                            hidden: !checkPermit.isDelete,
                                            buttonProps: {
                                                disabled: !selected_id_menu || !menu_detail.is_edit,
                                                onClick: () => selected_id_menu && handleDeleteMenu(selected_id_menu)
                                            },
                                            label: "ลบ",
                                            type: "DELETE_BIN"
                                        },
                                    ]}
                                />
                            </div>
                        }
                    />


                    {showModal !== "" && (
                        <ModalCustom
                            handleClose={handleCloseModal}
                            onClick={() => showModal === 'ADD' ? handleCreateMenu() : selected_id_menu && handleUpdateMenu(selected_id_menu)}
                            open
                            title={showModal === "ADD" ? "เพิ่มเมนู" : "แก้ไขเมนู"}
                            disabledSubmitButton={
                                !menu_detail.menu_name || !menu_detail.menu_link
                            }
                            subTitle='กรุณาระบุข้อมูลให้ครบถ้วนก่อนการยืนยัน'
                            form={
                                <div className='w-full py-5'>
                                    <StateComponents
                                        sxContainer={{ mt: 2 }}
                                        otherProps={{ spacing: 2 }}
                                        typeProps={[
                                            {
                                                seq: 1,
                                                type: "TEXT_FIELD",
                                                gridProps: {
                                                    xs: 12
                                                },
                                                fieldProps: {
                                                    required: true,
                                                    heading: "ชื่อเมนู",
                                                    onChange: (e) => handleChangeMenuDetail("menu_name", e.target.value),
                                                    value: menu_detail.menu_name
                                                }
                                            },
                                            {
                                                seq: 2,
                                                type: "TEXT_FIELD",
                                                gridProps: {
                                                    xs: 12
                                                },
                                                fieldProps: {
                                                    required: true,
                                                    heading: "เชื่อมโยงลิงก์",
                                                    endAdornment: <IconButton disabled={!menu_detail.menu_status_open} onClick={() => {
                                                        if (menu_detail.menu_status_open === MENU_RENDER_VIEW_ENUM.CURRENT_TAB) {
                                                            window.location.href = menu_detail.menu_link
                                                        } else if (menu_detail.menu_status_open === MENU_RENDER_VIEW_ENUM.NEW_TAB) {
                                                            window.open(menu_detail.menu_link, '_blank')
                                                        }
                                                    }}>
                                                        <IconComponents.LinkIcon />
                                                    </IconButton>,
                                                    onChange: (e) => handleChangeMenuDetail("menu_link", e.target.value),
                                                    value: menu_detail.menu_link
                                                }
                                            },
                                            {
                                                seq: 3,
                                                type: "RADIO",
                                                gridProps: {
                                                    xs: 12
                                                },
                                                fieldProps: {
                                                    row: true,
                                                    onChange: (e) => handleChangeMenuDetail("menu_status_open", e.target.value),
                                                    value: menu_detail.menu_status_open,
                                                    dataList: [
                                                        {
                                                            label: "อยู่ในหน้าเดิม",
                                                            value: MENU_RENDER_VIEW_ENUM.CURRENT_TAB
                                                        },
                                                        {
                                                            label: "เปิดหน้าใหม่",
                                                            value: MENU_RENDER_VIEW_ENUM.NEW_TAB
                                                        },
                                                    ],
                                                    heading: "การแสดงผล",
                                                    required: true
                                                }
                                            },
                                            {
                                                seq: 4,
                                                type: "AUTO-COMPLETE",
                                                gridProps: {
                                                    xs: 12,
                                                },
                                                fieldProps: {
                                                    getOptionLabel: (op) => op?.menu_name || "",
                                                    labelId: "menu_all_data",
                                                    options: menu_all_data,
                                                    onChange: (_, val) => handleChangeMenuDetail("id_menu_ref", val?.id_menu),
                                                    value: menu_all_data?.find((x) => x?.id_menu === menu_detail?.id_menu_ref) || null,
                                                    heading: "อยู่ภายใต้เมนู"
                                                }
                                            },
                                            // {
                                            //     seq: 5,
                                            //     type: "SELECT",
                                            //     gridProps: {
                                            //         xs: 12,
                                            //     },
                                            //     fieldProps: {
                                            //         labelId: "website_menu_data_id",
                                            //         options: website_menu_data,
                                            //         selectId: "website_menu_data",
                                            //         onChange: (e) => handleChangeMenuDetail('group_menu', e.target.value),
                                            //         value: menu_detail?.group_menu,
                                            //         heading: "หมวดหมู่การแสดงผลที่แผนผังเว็บไซต์"
                                            //     }
                                            // },
                                            {
                                                seq: 6,
                                                type: "SWITCH",
                                                gridProps: {
                                                    xs: 12
                                                },
                                                fieldProps: {
                                                    label: "ไม่แสดงบน Header",
                                                    checked: menu_detail?.is_not_show,
                                                    onChange: (st) => handleChangeMenuDetail('is_not_show', st),
                                                }
                                            }
                                        ]}
                                    />
                                </div>
                            }
                        />
                    )}
                </div>
            }
        />
    )
}

export default MenuStructure